import { PatternFormat } from "react-number-format";
import TextInput from "../Text";

type PhoneInputProps = {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
};

export default function PhoneInput({
  value,
  onChange,
  error,
  helperText,
}: PhoneInputProps) {
  return (
    <PatternFormat
      format="+55 (##) # ####-####"
      mask="_"
      value={value}
      onValueChange={(v) => onChange(v.value)}
      customInput={TextInput}
      label="Telefone"
      textSize="sm"
      placeholder="+55 (35) 9 9999-9999"
      fullWidth
      error={!!error}
      helperText={helperText}
    />
  );
}
